export default __webpack_public_path__ + "media/images/avatars/avatar12-12a19f31f8cd3c4b50eba4a437f43399.png";